import {StadiumModel} from "../../Models/StadiumModel";
import {useSelector} from "react-redux";
import {StateModel} from "../../Models/StateModel";

const useGetTokenOrRefresh = (auth: (body: any) => Promise<{token: string, stadium: StadiumModel}>): () => Promise<string> => {

    const stadium = useSelector<StateModel, StadiumModel | undefined>(state => state.stadium)

    return async () => {
        const token = localStorage.getItem("topivotoken")
        if (token) {
            return token
        } else {
            const body = {
                api_key: "qh6A9UkQ4rBL27493s86jPRCdhx36Y6W2NZT4eeh38Zy84Vj5iHpvwxMN2YMcf2Q",
                bart_key: "J3s2KekzVQCCy6U8rvXBB8g45L53Xfj6eG998KfeWc7uBZu4y42u6jWXQ3Njf753",
                stadium_reference: stadium?.reference
            }
            const res = await auth(body)
            const jwt = res.token
            localStorage.setItem("topivotoken", jwt)
            return jwt
        }
    }
}

export default useGetTokenOrRefresh
